/** Thread calls (2026-10-29): Discord's routes, the protocol's shapes. */
import {
  Routes,
  ThreadRoutes,
  type Channel,
  type MessageSearchResponse,
  type ModifyThreadRequest,
  type Snowflake,
  type StartThreadFromMessageRequest,
  type StartThreadRequest,
  type ThreadListResponse,
  type ThreadMember,
} from '@neosocial/protocol';
import { api } from '../lib/api';

export type ArchivedKind = 'public' | 'private' | 'joined';

export const threadsApi = {
  startFromMessage: (
    channelId: Snowflake,
    messageId: Snowflake,
    b: StartThreadFromMessageRequest,
  ) => api.client.post<Channel>(ThreadRoutes.messageThreads(channelId, messageId), b),
  start: (channelId: Snowflake, b: StartThreadRequest) =>
    api.client.post<Channel>(ThreadRoutes.channelThreads(channelId), b),
  modify: (threadId: Snowflake, b: ModifyThreadRequest) =>
    api.client.patch<Channel>(Routes.channel(threadId), b),
  delete: (threadId: Snowflake) => api.client.delete<Channel>(Routes.channel(threadId)),
  join: (threadId: Snowflake) => api.client.put<void>(ThreadRoutes.member(threadId, '@me'), {}),
  leave: (threadId: Snowflake) => api.client.delete<void>(ThreadRoutes.member(threadId, '@me')),
  add: (threadId: Snowflake, userId: Snowflake) =>
    api.client.put<void>(ThreadRoutes.member(threadId, userId), {}),
  remove: (threadId: Snowflake, userId: Snowflake) =>
    api.client.delete<void>(ThreadRoutes.member(threadId, userId)),
  members: (threadId: Snowflake) =>
    api.client.get<ThreadMember[]>(ThreadRoutes.members(threadId), {
      query: { with_member: true },
    }),
  active: (guildId: Snowflake) =>
    api.client.get<ThreadListResponse>(ThreadRoutes.guildActive(guildId)),
  archived: (channelId: Snowflake, kind: ArchivedKind, before?: string) =>
    api.client.get<ThreadListResponse>(
      kind === 'public'
        ? ThreadRoutes.archivedPublic(channelId)
        : kind === 'private'
          ? ThreadRoutes.archivedPrivate(channelId)
          : ThreadRoutes.joinedArchivedPrivate(channelId),
      { query: { before, limit: 50 } },
    ),
  search: (threadId: Snowflake, content: string) =>
    api.client.get<MessageSearchResponse>(Routes.channelMessagesSearch(threadId), {
      query: { content, limit: 25 },
    }),
};
